import { useCallback, useEffect, useState } from "react";
import Helper from "../Helper";
import PlotAPI from "../plotAPI";
import TeamInfo from "../teamInfo";

interface useCurrentTeamProps {
    usersTeams: TeamInfo[];
}

const useCurrentTeam = ({ usersTeams }: useCurrentTeamProps) => {
    const [currentTeam, _setCurrentTeam] = useState<null | TeamInfo>(null); // Current Team that the user is acting as
    const [currentTeamsProjects, setCurrentTeamsProjects] = useState<{
        member_of: any[];
        not_member_of: any[];
        projects: any[];
        recent_projects: any[];
        vendor_for: any[];
    }>({ member_of: [], not_member_of: [], projects: [], recent_projects: [], vendor_for: [] }); // Projects that the current Team belongs to (claimed and joined)

    const setCurrentTeam = useCallback(
        (teamId: number): void => {
            if (teamId && usersTeams) {
                const currentTeam = usersTeams.find((team) => team.id === teamId);

                if (currentTeam) {
                    Helper.setCookie("team", currentTeam.id.toString(), 365);
                    _setCurrentTeam(currentTeam);
                    return;
                } else if (usersTeams.length > 0) {
                    Helper.setCookie("team", usersTeams[0].id.toString(), 365);
                    _setCurrentTeam(usersTeams[0]);
                    return;
                }
            }

            _setCurrentTeam(null);
        },
        [usersTeams]
    );

    // Users Teams List Changed?
    useEffect(() => {
        if (usersTeams) {
            if (Helper.getCookie("team") === "" && usersTeams.length > 0) {
                // oxlint-disable-next-line react/set-state-in-effect We are running this slightly odd, but just to initialize it, then use setCurrentTeam to set it properly if needed
                setCurrentTeam(usersTeams[0].id);
            } else {
                const team_id = Helper.getCookie("team");
                setCurrentTeam(parseInt(team_id));
            }
        }
    }, [usersTeams, setCurrentTeam]);

    const reloadCurrentTeamsProjects = useCallback((): Promise<void> => {
        if (!currentTeam) {
            return Promise.resolve();
        }

        return PlotAPI.getProjectsOnTeam(currentTeam.subdomain).then((response) => {
            setCurrentTeamsProjects(
                response || { member_of: [], not_member_of: [], projects: [], recent_projects: [], vendor_for: [] }
            );
        });
    }, [currentTeam]);

    useEffect(() => {
        if (currentTeam) {
            reloadCurrentTeamsProjects();
        }
    }, [currentTeam, reloadCurrentTeamsProjects]);

    const reloadCurrentTeam = (): void => {
        if (!currentTeam) {
            return;
        }

        PlotAPI.getTeam(currentTeam.subdomain).then(() => {
            _setCurrentTeam(currentTeam);
        });
    };

    return { currentTeam, currentTeamsProjects, setCurrentTeam, reloadCurrentTeam, reloadCurrentTeamsProjects };
};

export default useCurrentTeam;
